export const text = (state) => {
  return state.notificationModal.text
}

export const type = (state) => {
  return state.notificationModal.type
}
